/* global require */
// depends-on: Bootstrap mobile
// depends-on: efw.local
(function ($) {
    const iframeResize = require('./iframeResizer'),
        parse = require('url-parse');

    // Eightfold Way popTool plugin for popping up try-it tools in iFrame inside a modal.
    $.fn.efw$popTool = function (/* options */) {
        return this.each(function () {
            let $this = $(this),
                name = $this.attr('rel'),
                modalId = 'modal_' + name,
                iframeId = 'iframe_' + name,
                url = parse();

            // do nothing if we're in edit-mode.
            if ($this.closest('.edit-mode').length > 0)
                return;

            // form targetUri for inner iFrame's social media: The tool on this page.
            url.set('hash', name);

            // strategy:
            // - Build a modal dialog structure specific to this tool.

            let $modal = $('<div class="modal popTool-modal" tabindex="-1" role="dialog" id="' + modalId + '" aria-label="' + 'general.label.popuptool'._local() + '"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"></div></div></div></div>');
            $modal.data('target', $this.attr('href'));
            $modal.data('wrapClass', $this.data('wrapClass'));
            $('body').append($modal);

            // - Reconfigure the link to launch the modal.
            $this.attr('data-toggle', 'modal')
                .attr('href', '#' + modalId);

            // - When activating the modal, load an iFrame internally. Set up resize communication system.
            $modal.on('show.bs.modal', function () {
                let $this = $(this),
                    $iframe = $('<iframe class="popToolFrame" id="' + iframeId + '" style="width: 1px; min-width: 100%; border: 0;"></iframe>'),
                    $iwrap = $('<div class="popToolWrap"></div>'),
                    targetUri = url.set('hash', name).href,
                    src = $(this).data('target'),
                    $spinner = $('<div class="spinner-wrap"><div class="spinner-border"></div></div>');
                // stick the targetUri as a querystring on the src
                src += (src.indexOf('?') > 0 ? '&' : '?') + 'targetUri=' + encodeURIComponent(targetUri.substring(targetUri.indexOf('://') + 3));
                $iwrap.addClass($this.data('wrapClass') || '').append($iframe);
                $this.find('.modal-body').append($spinner).addClass('spin').append($iwrap);
                $iframe.on('load', function () {
                    $this.find('.modal-body').removeClass('spin');
                    $this.css('min-height', '200px');
                    // scroll page back to the top of the modal. Modal is position: fixed.
                    $this.animate({ scrollTop: '0' }, 0);
                    if (!$(this).is('.loaded')) {
                        iframeResize({ log: false, sizeHeight: true, minHeight: 100, heightCalculationMethod: 'taggedElement' }, this);
                    }
                    $(this).addClass('loaded');
                }).attr('src', src);
            })
            // - When deactivating the modal, tear down the iFrame.
                .on('hide.bs.modal', function () {
                    $(this).find('.modal-body').empty();
            });

            $modal.efw$dialogAccessabilityRetrofit();
            // - wire up the resize messages.

            //$this.trackEvents({
            //    category: 'Clicks', action: 'ShowMore', label: function (o) {
            //        var $h2 = o.parent('div.helpAccordion').prevUntil('h2').first().prev('h2');
            //        return ($h2.length > 0 ? $h2.text() : '" + strShowMore + @"');
            //    }
            //});
        });
    };

    // Mini-plugin: Are we running in iFrame context? If so set a class on the selected object
    // https://stackoverflow.com/questions/4594492/check-if-parent-window-is-iframe-or-not
    $.fn.efw$inIframeContext = function () {
        return this.each(function () {
            try {
                if (self != top) {
                    $(this).addClass('in-frame');
                }
            } catch {
                // fail silently.
            }
        });
    }

    // activate globally.
    $(document).ready(function () {
        $('a.popTool').efw$popTool();
        $('body').efw$inIframeContext();
    });
})(jQuery);
